{
  "name": "01 Rainbow Fruit",
  "title": "RainbowFruitDescription",
  "description": "RainbowFruitUpgradeDescription1",
  "stat": 8,
  "lockFlag": 20
}